import React from 'react';
import { CheckCircle, Loader2, Save, FileEdit } from 'lucide-react';

export const CallDetailsFooter = ({
  saved,
  savedMessage,
  saving,
  savingDraft,
  currentDraftId,
  onSave,
  onSaveAsDraft,
  onClose,
}) => (
  <div className="border-t border-gray-800 px-6 py-4 bg-[#0a0a0f]">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2 text-gray-500 text-sm">
        {saved && (
          <>
            <CheckCircle className="w-4 h-4 text-green-400" />
            <span className="text-green-400">{savedMessage || 'Saved successfully!'}</span>
          </>
        )}
      </div>
      <div className="flex gap-3">
        {onClose && (
          <button
            onClick={onClose}
            className="px-5 py-2.5 border border-gray-700 text-gray-300 rounded-lg hover:bg-gray-800 transition-colors"
            data-testid="call-details-cancel-btn"
          >
            Cancel
          </button>
        )}
        <button
          onClick={onSaveAsDraft}
          disabled={savingDraft}
          className="flex items-center gap-2 px-5 py-2.5 bg-yellow-500/20 hover:bg-yellow-500/30 border border-yellow-500/30 text-yellow-400 rounded-lg font-medium transition-colors"
          data-testid="save-draft-btn"
        >
          {savingDraft ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <FileEdit className="w-4 h-4" />
              Save as Draft
            </>
          )}
        </button>
        <button
          onClick={onSave}
          disabled={saving}
          className="flex items-center gap-2 px-6 py-2.5 bg-teal-500 hover:bg-teal-600 disabled:bg-teal-500/50 text-white rounded-lg font-medium transition-colors"
          data-testid="save-form-btn"
        >
          {saving ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save className="w-4 h-4" />
              {currentDraftId ? 'Complete & Save' : 'Save Details'}
            </>
          )}
        </button>
      </div>
    </div>
  </div>
);
